import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Button, Container, Paper, Typography } from '@mui/material';
import TextFieldCustom from '../../../../components/TextField/TextFieldCustom';
import RadioButton from '../../../../components/RadioButton/RadioButton';
import Grid from '@mui/material/Unstable_Grid2';
import useTemplateCreatorPage from './useTemplateCreatorPage';
import { FIELDTYPE } from '../../../../constants/field-type';
import FormLabel from '@mui/material/FormLabel';
import AlertBar from '../../../../components/AlertBar/AlertBar';
import SelectCustom from '../../../../components/Select/SelectCustom';
import PreviewTemplate from './PreviewTemplate';


function TemplateCreatorPage() {

    const {
        templateState,
        buttonAction,
        handleRichTextUpdate,
        fields,
        handleFieldChange,
        showAlert,
        formName,
        loaded,
    } = useTemplateCreatorPage();
    
    return (
        <div>
            <Container maxWidth="xl" sx={{ mb: 4 }}>
                <Paper elevation={5} sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
                    <Typography variant="h5" sx={{ mb: 2, textAlign: "center" }}> {formName} </Typography>
                    {loaded &&
                        <Grid container spacing={2}>
                            {fields.map(field => {
                                switch (field.fieldType) {
                                    case FIELDTYPE.TEXT:
                                        return <TextFieldCustom
                                            label={field.label}
                                            size={field.size}
                                            setValue={(val) => { handleFieldChange(val, field.fieldVal) }}
                                            value={templateState[field.fieldVal]}
                                            key={field.label}
                                            disabled={field.disabled}
                                        // setValue: (val) => handleFieldChange(val, field.FieldName2),
                                        />
                                    case FIELDTYPE.DROP_DOWN:
                                        return <SelectCustom
                                            label={field.label}
                                            size={field.size}
                                            setValue={(val) => { handleFieldChange(val, field.fieldVal) }}
                                            value={templateState[field.fieldVal]}
                                            key={field.label}
                                            disabled={field.disabled}
                                            options={field.options}
                                            disable={field.disabled}
                                        // setValue: (val) => handleFieldChange(val, field.FieldName2),
                                        />
                                    case FIELDTYPE.RADIO:
                                        return <RadioButton
                                            label={field.label}
                                            options={field.options}
                                            setValue={(val) => { handleFieldChange(val, field.fieldVal) }}
                                            value={templateState[field.fieldVal]}
                                            size={field.size}
                                            key={field.label}
                                        />
                                    case FIELDTYPE.RICHTEXT:
                                        return <div>
                                            <FormLabel id="demo-row-radio-buttons-group-label">{field.label}</FormLabel>
                                            <Editor
                                                key={field.label}
                                                tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce-v7/tinymce.min.js'}
                                                onEditorChange={(value) => handleRichTextUpdate(field.fieldVal, value)}
                                                value={templateState[field.fieldVal]}
                                                init={{
                                                    height: 600,
                                                    plugins: 'print preview paste searchreplace fullscreen link image table charmap hr toc insertdatetime advlist lists wordcount imagetools textpattern noneditable charmap quickbars code fontsize',
                                                    menubar: 'file edit view insert format tools table',
                                                    toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect fontsize | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | lineheight |forecolor backcolor removeformat | charmap | fullscreen preview print | quickimage quicktable',
                                                    toolbar_sticky: true,
                                                    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                                                    noneditable_noneditable_class: 'mceNonEditable',
                                                    toolbar_mode: 'sliding',
                                                    // content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                                    elementpath: false,
                                                    branding: false,
                                                    font_size_formats: '6px 7px 8px 9px 10px 11px 12px 14px 16px 18px 24px 36px'
                                                }}
                                            />
                                        </div>
                                    default:
                                        return null
                                }

                            })}
                        </Grid>
                    }
                    <br></br>
                    {!showAlert.show &&
                        <>
                        
                        {/* {templateState.formTemplate && 
                            <PreviewTemplate
                                formHtmlTemplate={templateState.formTemplate}
                                header={templateState.header}
                                footer={templateState.footer}
                            />   
                        } */}
                            {/* <Button
                                variant="outlined"
                                onClick={buttonAction.handleClicked}
                                sx={{ m:1}}
                            >
                                Generate HTML
                            </Button> */}
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={buttonAction.handleSubmit}
                            >
                                Submit
                            </Button>
                        </>
                    }
                    <AlertBar
                        showAlert={showAlert.show}
                        severity={showAlert.severity}
                        alertMessage={showAlert.message}
                    />
                </Paper>

            </Container>



        </div>
    );
}

export default TemplateCreatorPage;